import React, { useCallback, useEffect, useState } from 'react'
import { apiChangeConfigurations, apiGetConfigurations, apiChangeAppVersion } from '../../../../utils/api'
import { Switch, Table, Tag, Tooltip, Modal, Button } from 'antd' // ✅ AGREGAR Modal y Button
import isAllowed, { ROLES_DIVISIONS } from '../../../../layout/roles'
import { useSelector } from 'react-redux'
import Input from 'antd/lib/input/Input'
import { ExclamationCircleOutlined } from '@ant-design/icons' // ✅ AGREGAR ICONO

export const ConfigurationsPage = () => {

  const [data, setdata] = useState([])
  const [loading, setloading] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [modalVisible, setModalVisible] = useState(false) // ✅ AGREGAR STATE PARA MODAL

  const { user } = useSelector(state => state.session)

  const getData = useCallback(() => {
    setloading(true)
    apiGetConfigurations().then(res => {
      let datos = res.data.filter(i => i.typeServices === 'app_version')
      let version = JSON.parse(datos[0]["urlImage"])
      setInputValue(version.appVersion)
      res.data = res.data.filter(i => {
        return !i.isExclusiveToSuperAdmin || (i.isExclusiveToSuperAdmin && isAllowed(user, ROLES_DIVISIONS.PURE_ADMIN))
      })
      setdata(res.data.filter(i => i.typeServices !== 'template'))
    }).catch(err => {
      new Error(err)
    }).finally(() => {
      setloading(false)
    })
  }, [])

  const handleInput = (event) => {
    setInputValue(event.target.value) 
  }
   
  // ✅ MODIFICAR - Ahora solo abre el modal
  const handleKey = (event) => {
    setModalVisible(true)
  }

  // ✅ NUEVA FUNCIÓN - Llama a la API y cierra sesión
  const handleConfirmChange = () => {
    apiChangeAppVersion(inputValue).then(res => {
      // Cerrar modal
      setModalVisible(false)
      
      // Cerrar sesión
      sessionStorage.clear()
      localStorage.clear()
      
      // Redirigir a login
      window.location.href = '/login' // O la ruta de tu login
      
    }).catch(err => {
      console.error('Error al cambiar versión:', err)
      setModalVisible(false)
    })
  }

  // ✅ NUEVA FUNCIÓN - Cancelar
  const handleCancelChange = () => {
    setModalVisible(false)
  }

  const handleChange = (value, item) => {
    apiChangeConfigurations(value ? 1 : 0, item.idConfiguration).then(res => {
      getData()
    }).catch(err => {
      new Error(err)
    })
  }

  const columns = [
    {
      title: 'Descripción',
      render: row => (
        <div>
          <div>
            {row.nameServices}
          </div>
        </div>
      )
    },
    {
      title: 'Status',
      width: '20%',
      render: row => (
        <div style={{ display: 'flex', }}>
          {
            row.typeServices === 'SmsEnable'
              ?
              <>
                {row.active ? <Tag color='green'>Twilio</Tag> : <Tag color='green'>SMS API</Tag>}
              </>
              :
              <>
                {row.active ? <Tag color='green'>Activo</Tag> : <Tag color='red'>Inactivo</Tag>}
              </>
          }
        </div>
      )
    },
    {
      title: 'Accion',
      width: '15%',
      render: row => (
        <div style={{ display: 'flex', alignItems: 'center',  }}>
          {
            row.typeServices === 'SmsEnable'
              ?
              <>
                <Tooltip title={`${row.active ? 'Cambiar a SMS Api' : 'Cambiar a Twilio'}`}>
                  <Switch checked={row.active} onChange={e => handleChange(e, row)} />
                </Tooltip>
              </>
              :
              <>
                <Tooltip title={`${row.active ? 'Desactivar' : 'Activar'}`}>
                  <Switch checked={row.active} onChange={e => handleChange(e, row)} />
                </Tooltip>
              </>
          }
        </div>
      )
    },
    {
      title: "",
      width: '15%',
      render: row => (
        row.typeServices === 'app_version'
        ?
        <div>
          <Input 
            value={inputValue} 
            onChange={e => handleInput(e)} 
            onKeyPress={e => { if(e.key === 'Enter') {handleKey(e)} }}
          />
        </div>
        : ""
      )
    },
  ]

  useEffect(() => {
    getData()
  }, [getData])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <div style={{ width: '100%', height: 1, opacity: .1, backgroundColor: '#000' }}></div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', width: '100%' }}>
        <Table
          rowKey={record => record.idConfiguration}
          loading={loading}
          columns={columns}
          dataSource={data}
          size='large'
          scroll={{ y: '60vh', x: '100%' }}
        />
      </div>

      {/* ✅ AGREGAR MODAL */}
      <Modal
        visible={modalVisible}
        onCancel={handleCancelChange}
        footer={null}
        centered
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <ExclamationCircleOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
          <h3>Cambiar versión de la aplicación</h3>
          <p>Al cambiar la versión de la aplicación, se cerrará tu sesión automáticamente.</p>
          <p style={{ fontWeight: 'bold' }}>¿Deseas continuar?</p>
          
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '24px' }}>
            <Button onClick={handleCancelChange}>
              Cancelar
            </Button>
            <Button type="primary" onClick={handleConfirmChange}>
              Aceptar
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}